module.exports = __webpack_public_path__ + "fonts/fontawesome/fa-sharp-thin-100.ttf";